import { apiClient } from "@/services/apiClient";

const PUBLIC_API_CONFIG = {
  skipAuthRefresh: true,
} as const;

export async function submitContactMessageApi(payload: {
  name: string;
  email: string;
  phone: string;
  message: string;
  locale: string;
  whatsapp_group_name?: string;
}) {
  const response = await apiClient.post("/api/contact-messages", payload, PUBLIC_API_CONFIG);

  return response.data;
}
